import axios from "axios";

const codeMessage = {
  200: { message: "请求成功", description: "服务器成功返回请求的数据。" },
  201: { message: "请求成功", description: "新建或修改数据成功。" },
  202: {
    message: "请求成功",
    description: "一个请求已经进入后台排队（异步任务）。",
  },
  204: { message: "请求成功", description: "删除数据成功。" },
  400: {
    message: "请求失败",
    description: "发出的请求有错误，服务器没有进行新建或修改数据的操作。",
  },
  401: {
    message: "登录失败",
    description: "用户没有权限（用户名、密码错误）。",
  },
  402: { message: "登录过期", description: "用户认证信息过期，请重新登录。" },
  403: {
    message: "请求失败",
    description: "用户得到授权，但是访问是被禁止的。",
  },
  404: {
    message: "请求失败",
    description: "发出的请求针对的是不存在的记录，服务器没有进行操作。",
  },
  406: { message: "请求失败", description: "请求的格式不可得。" },
  410: {
    message: "请求失败",
    description: "请求的资源被永久删除，且不会再得到的。",
  },
  422: {
    message: "请求失败",
    description: "当创建一个对象时，发生一个验证错误。",
  },
  500: { message: "服务器异常", description: "服务器发生错误，请检查服务器。" },
  502: { message: "服务器异常", description: "网关错误。" },
  503: {
    message: "服务器异常",
    description: "服务不可用，服务器暂时过载或维护。",
  },
  504: { message: "服务器异常", description: "网关超时。" },
};

const request = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? "/dev-api" : "/api",
  timeout: 30000,
});

request.interceptors.request.use(
  (config) => {
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

request.interceptors.response.use(
  (response) => {
    const dataAxios = response.data;
    const { code, data, msg } = dataAxios;

    switch (code) {
      // 未包装的相应数据直接返回
      case undefined:
        return dataAxios;
      // return response;
      // 没有错误
      case 0:
        return data;
      // code无效
      default:
        return Promise.reject(new Error(msg));
    }
  },
  (error: { response: Response; request: Request }) => {
    const { response } = error;

    let errorText;

    if (response && response.status) {
      errorText = codeMessage[response.status as keyof typeof codeMessage] || {
        message: "请求失败",
        description: response.statusText,
      };
    } else {
      errorText = {
        message: "网络异常",
        description: "您的网络发生异常，无法连接服务器。",
      };
    }

    console.log(`${errorText.message}: ${errorText.description}`, error);

    return Promise.reject(error);
  }
);

export default request;
